const PHRASES = [
  'Подготавливаем пространство для вашего бренда…',
  'Загружаем идеи, кейсы и свежие решения…',
  'Собираем пиксели в смысл — digital без лишнего шума…',
  'Настраиваем атмосферу студии специально для вас…',
  'Почти у цели — осталось совсем чуть-чуть…',
]

const PHRASE_MS = 2600
const MIN_VISIBLE_MS = 850
/** Если внешний ресурс (например, шрифты) не догружается, `load` не наступает — уходим с экрана самостоятельно. */
const MAX_WAIT_BEFORE_HIDE_MS = 12000

/**
 * Полноэкранный прелоадер: фразы, скрытие после window.load и минимального времени.
 */
export function initPreloader() {
  const root = document.querySelector('[data-preloader]')
  if (!root) {
    return
  }

  const phraseEl = root.querySelector('[data-preloader-phrase]')
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const startedAt = performance.now()

  document.body.classList.add('preloader-lock')

  let phraseIdx = 0
  let phraseTimer

  const setPhrase = (index) => {
    if (!phraseEl) {
      return
    }
    phraseEl.textContent = PHRASES[index % PHRASES.length]
  }

  const tickPhrase = () => {
    if (!phraseEl || reducedMotion) {
      return
    }
    phraseIdx += 1
    phraseEl.classList.add('is-switching')
    window.setTimeout(() => {
      setPhrase(phraseIdx)
      phraseEl.classList.remove('is-switching')
    }, 180)
  }

  setPhrase(0)

  if (!reducedMotion && PHRASES.length > 1) {
    phraseTimer = window.setInterval(tickPhrase, PHRASE_MS)
  }

  let hideCommitted = false

  const cleanup = () => {
    if (phraseTimer) {
      window.clearInterval(phraseTimer)
    }
    document.body.classList.remove('preloader-lock')
    root.classList.add('is-done')
    root.setAttribute('aria-busy', 'false')
    window.setTimeout(() => {
      root.remove()
    }, 600)
  }

  const scheduleHide = () => {
    if (hideCommitted) {
      return
    }
    hideCommitted = true
    const elapsed = performance.now() - startedAt
    const rest = Math.max(0, MIN_VISIBLE_MS - elapsed)
    window.setTimeout(cleanup, reducedMotion ? 0 : rest)
  }

  if (document.readyState === 'complete') {
    scheduleHide()
    return
  }

  window.addEventListener('load', scheduleHide, { once: true })
  window.setTimeout(scheduleHide, MAX_WAIT_BEFORE_HIDE_MS)
}
